import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Card = styled.div`
  margin-bottom: 1.5rem;
`;

const CardImage = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  line-height: 1.3;
`;

const CardByline = styled.p`
  font-size: 0.8rem;
  font-style: italic;
  color: ${props => props.theme.colors.text};
  opacity: 0.8;
`;

const ArticleCard = ({ article }) => {
  return (
    <Card>
      <Link to={`/article/${article.id}`}>
        <CardImage src={article.image_url || article.imageUrl} />
        <CardTitle>{article.title}</CardTitle>
      </Link>
      <CardByline>
        By {article.author} | {new Date(article.published_at || article.publishedAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })}
      </CardByline>
    </Card>
  );
};

export default ArticleCard;